import classNames from 'classnames';
import { useFormControlContext } from './useFormControl';
import { ComplexTooltip } from '../presentational/tooltip';
import { ReactNode, DetailedHTMLProps, LabelHTMLAttributes } from 'react';

interface IFormControlLabelProps
  extends DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> {
  children?: ReactNode;
  helpText?: string;
  helpTooltip?: ReactNode;
  element?: string;
}

export const FormControlLabel = (props: IFormControlLabelProps) => {
  const { children, className, helpText, id, helpTooltip, ...restProps } = props;
  const { required, onLabelClick, labelSize } = useFormControlContext() || {};

  const Element = props.element || ('label' as any);

  return (
    <Element
      htmlFor={id}
      onClick={onLabelClick}
      className={classNames('slds-form-element__label', className, {
        'slds-text-heading--small': labelSize === 'large'
      })}
      {...restProps}
    >
      {required && (
        <span className="slds-required" title="required">
          *{' '}
        </span>
      )}
      {children}
      {helpText && <i className="text-muted text-italic slds-text-body--small"> ({helpText})</i>}
      {helpTooltip && (
        <ComplexTooltip tooltip={helpTooltip} tag="span" placement="top">
          <i className="fas fa-question-circle slds-m-left--x-small color-white slds-text-body--small" />
        </ComplexTooltip>
      )}
    </Element>
  );
};
